import React, { useState, useEffect } from 'react';

const MembershipTimer = ({ endDate, membershipName}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });


  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const end = new Date(endDate);
      const diff = end - now;

      if (diff <= 0) {
        clearInterval(timer);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  return (
    <div className="bg-indigo-100 border-l-4 border-indigo-500 p-4 mb-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
        <div className="mb-2 sm:mb-0">
          <h3 className="font-bold text-indigo-800">
            {membershipName} Membership Active
          </h3>
          <p className="text-sm text-indigo-600">
            Expires on: {new Date(endDate).toLocaleDateString()}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          {timeLeft.days > 0 && (
            <div className="bg-white px-3 py-1 rounded shadow">
              <span className="font-bold text-indigo-600">{timeLeft.days}</span> দিন
            </div>
          )}
          <div className="bg-white px-3 py-1 rounded shadow">
            <span className="font-bold text-indigo-600">{timeLeft.hours}</span> ঘণ্টা
          </div>
          <div className="bg-white px-3 py-1 rounded shadow">
            <span className="font-bold text-indigo-600">{timeLeft.minutes}</span> মিনিট
          </div>
          <div className="bg-white px-3 py-1 rounded shadow">
            <span className="font-bold text-indigo-600">{timeLeft.seconds}</span> সেকেন্ড
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipTimer;